module.exports = __webpack_public_path__ + "img/4.370c929d.jpg";